import { useMemo } from 'react'
import { ActivityType } from '@/api/models/activity'
import { useAppSelector } from '@/store/hooks'

export const useDataLakeContextVariables = () => {
  const aggregate = useAppSelector((store) => store.aggregate.current)
  const activityWorkflows = useAppSelector((store) => store.aggregate.aggregates)
  const objectiveRecords = useAppSelector((store) => store.aggregate.records)

  const activityWorkflowId = activityWorkflows?.[0]?.lastActivityWorkflow?.id!

  const objectiveAttempt = objectiveRecords?.length

  // for activities inside composition
  const activityRecords = useAppSelector((store) => store.aggregate.activityRecords)

  // for courses list etc.
  const searchText = useAppSelector((store) => store.aggregates.enrolledCoursesSearchText)

  return useMemo(() => {
    const objective = aggregate?.objective
    const lastObjectiveWorkflow = aggregate?.lastObjectiveWorkflow
    const lastObjectiveRecord = aggregate?.lastObjectiveRecord

    const isComposition = objective?.activity?.type === ActivityType.composite

    const isNotFinished = !lastObjectiveWorkflow?.finished

    const contextObject: Record<string, string> = {}

    // it means we are in the context of an objective
    if (aggregate) {
      contextObject.objective = objective?.id!
      contextObject.objective_attempt = isNotFinished
        ? (objectiveAttempt + 1)?.toString()
        : objectiveAttempt?.toString()
      contextObject.objective_progress = lastObjectiveWorkflow?.progress?.toString()!
      contextObject.objective_passed = lastObjectiveRecord?.passed?.toString()!
      contextObject.activity = objective?.activity?.id!
      contextObject.enrollment = aggregate?.objectiveAccess?.id!
      contextObject.objective_workflow = lastObjectiveWorkflow?.id!
      contextObject.activity_workflow = activityWorkflowId
      contextObject.activity_progress = lastObjectiveRecord?.progress?.toString()!

      if (isComposition) {
        contextObject['activity_attempt'] = activityRecords?.length?.toString()
      } else {
        // it's always 1 for non-composition activities
        contextObject['activity_attempt'] = '1'

        // for non-composition activities, activity_passed always equals to objective_passed
        contextObject['activity_passed'] = lastObjectiveRecord?.passed?.toString()!
      }
    }

    if (searchText) {
      contextObject.search_string = searchText
    }

    return contextObject
  }, [aggregate, searchText, objectiveAttempt, activityWorkflowId, activityRecords?.length])
}
